import "../styles/hero.css";

export default function Hero() {
  return (
    <section className="hero">
      {/* Background Video */}
      <video className="hero-video" autoPlay muted loop playsInline>
        <source src="/assets/hero/lutyens-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="overlay">
        <div className="hero-content">
          <h1></h1>
          <p></p>
        </div>
      </div>
    </section>
  );
}
